module.exports = __webpack_public_path__ + "static/media/whatsappchatbg.bb9de633.jpeg";